import { createSlice } from '@reduxjs/toolkit'

import {
  fetchInstalledApps,
  uninstallApplication,
} from 'apps/applications/actions/installedApplicationsActions'
import { fetchApplicationActions } from 'common/actions/integrations/Applications/actions/accountApplicationsActions'
import { InstalledApplication } from 'shared/api/common/schemas/applications'

const initialState: InstalledApplication[] = []

export const installedApplicationsSlice = createSlice({
  name: 'installedApplications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchApplicationActions.fulfilled, (state, action) => {
      const applicationId = action.meta.arg

      if (action.payload && applicationId) {
        const index = state.findIndex((element) => element.app_id === applicationId)
        if (index >= 0) {
          state[index].actions = action.payload.actions
        }
      }
    })

    builder.addCase(fetchInstalledApps.fulfilled, (state, action) => {
      if (!action.payload) return state

      return action.payload
    })

    builder.addCase(uninstallApplication.fulfilled, (state, action) => {
      const applicationId = action.meta.arg
      const index = state.findIndex((item) => item.app_id === applicationId)

      if (index >= 0) {
        state.splice(index, 1)
      }
    })
  },
})

export const { reducer } = installedApplicationsSlice
